module.exports = __webpack_public_path__ + "static/img/img_system.edd17a60.png";